/* Wallet claim moment (#1385, 31.10.2026) — ONE copy deck + two surfaces, shared by the shelf grid
 * (afroyla-wallet-shelf.js) and the wallet page opened from the shelf (afroyla-wallet-set-notice.js).
 *   after wallet 1 → "CLAIM 2 WALLETS FREE"        + one button back to the shelf ("Pick my 2 free wallets")
 *   after wallet 2 → "1 MORE FREE WALLET TO CLAIM"  + the same button ("Pick my last free wallet")
 *   after wallet 3 → "SET COMPLETE · 2 WALLETS FREE" + Checkout as the primary action
 * Surfaces: (a) a confirmation sheet the grid shows after a silent add (no picker inside — the choosing stays on the
 * shelf); (b) a box at the top of Horizon's cart drawer on both pages (re-attached when the drawer re-renders).
 * The button keeps the shopper on the grid when already there (close sheet/drawer, scroll to the shelf) and links back
 * to the shelf (#pick → the grid restores tab + scroll) from the wallet page. Maths come from the caller: {n, pay, free}. */
window.AflWalletClaim = function (cfg) {
  var mode = cfg.mode === 'pdp' ? 'pdp' : 'grid';
  var lpUrl = cfg.lpUrl || '/pages/wallet-shelf';
  var money = cfg.money || function (n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---- copy (English, short, the same on grid, wallet page and drawer) ---- */
  function words(q) {
    var n = q.n, target = n === 0 ? 3 : Math.ceil(n / 3) * 3, left = target - n, full = n > 0 && left === 0, next = n > 3;
    var w = { n: n, target: target, left: left, full: full, free: q.free, pay: q.pay, dots: n % 3 || (n ? 3 : 0) };
    w.progress = full ? n + ' picked · ' + q.free + ' FREE' : n + ' of ' + target + ' picked';
    if (full) {
      w.head = 'Set complete · ' + q.free + ' wallets FREE';
      w.body = n + ' wallets for ' + money(q.pay) + '. The ' + q.free + ' cheapest are FREE in your cart, no code.';
      w.cta = 'Checkout · ' + money(q.pay); w.alt = 'Add 3 more, get 2 more FREE';
    } else if (left === 2) {
      w.head = next ? 'Claim 2 more wallets FREE' : 'Claim 2 wallets FREE';
      w.body = 'Pick any 2 more on the shelf. 2 of your ' + (next ? 'next 3' : '3') + ' come FREE in the cart, no code.';
      w.cta = 'Pick my 2 free wallets'; w.alt = 'View cart';
    } else {
      w.head = '1 more FREE wallet to claim';
      w.body = 'Pick 1 more on the shelf. It completes your ' + (next ? 'next ' : '') + '3, 2 of them FREE.';
      w.cta = 'Pick my last free wallet'; w.alt = 'View cart';
    }
    return w;
  }
  function dots(w) { return '<span class="afl-claim__dots" aria-hidden="true">' + [0, 1, 2].map(function (i) { return '<i class="' + (i < w.dots ? 'is-on' : '') + '"></i>'; }).join('') + '</span>'; }
  /* the ONE primary button: grid = stays on the page (callback), wallet page = link back to the shelf with #pick */
  function pickBtn(w, cls) {
    var label = esc(w.full ? w.alt : w.cta);
    if (mode === 'pdp') return '<a class="' + cls + '" href="' + esc(lpUrl) + '#pick" data-afl-claim-pick data-hc-el="teaser-cta">' + label + '</a>';
    return '<button type="button" class="' + cls + '" data-afl-claim-pick data-hc-el="teaser-cta">' + label + '</button>';
  }
  function checkoutBtn(w) { return '<button type="button" class="afl-claim__btn" data-afl-claim-checkout data-hc-el="x-wc-cta">' + esc(w.cta) + '</button>'; }

  /* ---- actions ---- */
  function closeDrawer() { var d = document.getElementById('cart-drawer'); if (d && typeof d.close === 'function') d.close(); }
  function checkout() {
    var b = document.querySelector('#cart-drawer button[name="checkout"], #cart-drawer #checkout');
    if (b) b.click(); else location.href = '/checkout';
  }
  function onClick(e) {
    var t = e.target.closest('[data-afl-claim-pick],[data-afl-claim-checkout],[data-afl-claim-cart],[data-afl-claim-close]');
    if (!t) return;
    if (t.hasAttribute('data-afl-claim-checkout')) { e.preventDefault(); hide(); checkout(); return; }
    if (t.hasAttribute('data-afl-claim-cart')) { hide(); if (cfg.onCart) cfg.onCart(); return; }
    if (t.hasAttribute('data-afl-claim-close')) { hide(); return; }
    if (mode === 'pdp') return; // the link navigates back to the shelf
    e.preventDefault(); hide(); closeDrawer(); if (cfg.onPick) cfg.onPick();
  }

  /* ---- surface A · confirmation sheet (grid, after a silent add) ---- */
  var sheet = null, lastFocus = null;
  function hide() {
    if (!sheet) return;
    sheet.classList.remove('is-on'); document.documentElement.classList.remove('afl-claim-open');
    var s = sheet; sheet = null; setTimeout(function () { s.remove(); }, 220);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function show(q, item) {
    hide(); var w = words(q);
    lastFocus = document.activeElement;
    sheet = document.createElement('div'); sheet.className = 'afl-claim' + (w.full ? ' is-full' : ''); sheet.setAttribute('data-hc-section', 'wallet-clear');
    sheet.innerHTML = '<div class="afl-claim__scrim" data-afl-claim-close></div>' +
      '<div class="afl-claim__card" role="dialog" aria-modal="true" aria-labelledby="afl-claim-h">' +
      '<button type="button" class="afl-claim__x" aria-label="Close" data-afl-claim-close>&times;</button>' +
      (item ? '<p class="afl-claim__added">' + (item.img ? '<img src="' + esc(item.img) + '" alt="" width="48" height="48">' : '') + '<span>Added ✓ <b>“' + esc(item.name) + '”</b></span></p>' : '') +
      '<p class="afl-claim__eyebrow">' + dots(w) + esc(w.progress) + '</p>' +
      '<h2 class="afl-claim__h" id="afl-claim-h">' + esc(w.head) + '</h2>' +
      '<p class="afl-claim__body">' + esc(w.body) + '</p>' +
      (w.full ? checkoutBtn(w) + pickBtn(w, 'afl-claim__link') : pickBtn(w, 'afl-claim__btn') + '<button type="button" class="afl-claim__link" data-afl-claim-cart>' + esc(w.alt) + '</button>') +
      '</div>';
    sheet.addEventListener('click', onClick);
    document.body.appendChild(sheet);
    requestAnimationFrame(function () { sheet && sheet.classList.add('is-on'); document.documentElement.classList.add('afl-claim-open'); var b = sheet && sheet.querySelector('.afl-claim__btn'); if (b) b.focus({ preventScroll: true }); });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet) hide(); });

  /* ---- surface B · box at the top of the cart drawer (both pages) ---- */
  var boxHtml = '', boxFull = false, obs = null;
  function drawer(q, extraHtml) {
    if (!q || (!q.n && !extraHtml)) { boxHtml = ''; place(); return; }
    var w = words(q);
    boxHtml = '<p class="afl-claim__eyebrow">' + dots(w) + esc(w.progress) + '</p><p class="afl-claim__h afl-claim__h--sm">' + esc(w.head) + '</p>' +
      '<p class="afl-claim__body">' + esc(w.body) + '</p>' + (extraHtml || '') +
      (w.full ? checkoutBtn(w) + pickBtn(w, 'afl-claim__link') : pickBtn(w, 'afl-claim__btn'));
    boxFull = w.full; place();
  }
  function place() {
    var body = document.querySelector('#cart-drawer .afl-cart-drawer__body, #cart-drawer .cart-drawer__items');
    if (!body) return;
    var box = body.querySelector(':scope > .afl-claim__cart');
    if (!boxHtml) { if (box) box.remove(); return; }
    if (obs) obs.disconnect();
    /* the box carries an id so Horizon's morph (assets/morph.js) matches it by id instead of pairing it positionally with the first .afl-cart-line */
    if (!box) { box = document.createElement('div'); box.id = 'afl-claim-cart-box'; box.className = 'afl-claim__cart'; box.setAttribute('role', 'status'); box.setAttribute('data-hc-section', 'cart-drawer'); box.addEventListener('click', onClick); body.insertBefore(box, body.firstChild); }
    if (box.innerHTML !== boxHtml) box.innerHTML = boxHtml;
    box.classList.toggle('is-full', boxFull);
    observe();
  }
  function observe() {
    var d = document.getElementById('cart-drawer');
    if (!d || !window.MutationObserver) return;
    if (!obs) obs = new MutationObserver(place);
    obs.observe(d, { childList: true, subtree: true });
  }
  observe();

  return { words: words, show: show, hide: hide, drawer: drawer, pickBtn: pickBtn, closeDrawer: closeDrawer };
};
